import { useTranslation } from 'react-i18next';

import { IconMail03 } from '@pentabd/icons';
import { Avatar, Button, Header, Modal } from '@pentabd/ui';

import RichTextEditor from './RichTextEditor';

interface MailModalType {
  isModalOpen: boolean;
  closeModal: () => void;
}

const MailModal = ({ isModalOpen, closeModal }: MailModalType) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={closeModal}
      closeAble
    >
      <Header
        size="sm"
        headerText={{
          header: 'মোছাঃ আছিয়া খাতুন',
          subHeader: 'mst.asia@acc.com',
        }}
        avatar={<Avatar size="sm" />}
        className="px-9"
      />
      <div className="px-9 w-100">
        <RichTextEditor />
        <div className="w-max ml-auto mt-10 mb-9">
          <Button
            size="sm"
            htmlType="submit"
            fill="fill"
            type="primary"
          >
            <IconMail03 fill="white" size={20} />
            {t('ATTENDANCE.TABLE.SEND_BUTTON')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MailModal;
